module.exports = __webpack_public_path__ + "33e866d1e5903e1ca5724ce5768b8d48.svg";